
import { focus } from 'vue-focus'

export default {
  name: 'bookmark',
  directives: { focus },
  data: function() {
    return {
      editing: false,
      comment: this.bookmark.comment,
      submit: false,
      focus: false,
    }
  },
  props: {
    bookmark: Object,
    magazine: Object,
    deleted: Boolean,
  },
  computed: {
    url: function() {
      return this.bookmark.pdf_page ? this.bookmark.pdf_url : this.bookmark.html_url
    }
  },
  methods: {
    remove: function() {
      this.$emit('remove', this.bookmark)
    },
    edit: function() {
      this.editing = true
      this.focus = true
    },
    cancel: function(e) {
      this.editing = false
      this.focus = false
      this.comment = this.bookmark.comment
    },
    save: function() {
      if (this.submit) {
        this.bookmark.comment = this.comment
        this.$emit('save', this.bookmark)
      }
      this.focus = false
      this.editing = false
    },
    restore: function() {
      this.$emit('restore', this.bookmark)
    },
    detectChanges: function() {
      this.submit = this.bookmark.comment !== this.comment
    }
  }
}
